/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getTimestamp } from "../graphql/queries";
import { updateTimestamp } from "../graphql/mutations";
const client = generateClient();
export default function TimestampUpdateForm(props) {
  const {
    id: idProp,
    timestamp: timestampModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    type: "",
    fromTime: "",
    toTime: "",
    comment: "",
  };
  const [type, setType] = React.useState(initialValues.type);
  const [fromTime, setFromTime] = React.useState(initialValues.fromTime);
  const [toTime, setToTime] = React.useState(initialValues.toTime);
  const [comment, setComment] = React.useState(initialValues.comment);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = timestampRecord
      ? { ...initialValues, ...timestampRecord }
      : initialValues;
    setType(cleanValues.type);
    setFromTime(cleanValues.fromTime);
    setToTime(cleanValues.toTime);
    setComment(cleanValues.comment);
    setErrors({});
  };
  const [timestampRecord, setTimestampRecord] =
    React.useState(timestampModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getTimestamp.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getTimestamp
        : timestampModelProp;
      setTimestampRecord(record);
    };
    queryData();
  }, [idProp, timestampModelProp]);
  React.useEffect(resetStateValues, [timestampRecord]);
  const validations = {
    type: [],
    fromTime: [{ type: "Required" }],
    toTime: [{ type: "Required" }],
    comment: [{ type: "Required" }],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          type: type ?? null,
          fromTime,
          toTime,
          comment,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateTimestamp.replaceAll("__typename", ""),
            variables: {
              input: {
                id: timestampRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "TimestampUpdateForm")}
      {...rest}
    >
      <TextField
        label="Type"
        isRequired={false}
        isReadOnly={false}
        value={type}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              type: value,
              fromTime,
              toTime,
              comment,
            };
            const result = onChange(modelFields);
            value = result?.type ?? value;
          }
          if (errors.type?.hasError) {
            runValidationTasks("type", value);
          }
          setType(value);
        }}
        onBlur={() => runValidationTasks("type", type)}
        errorMessage={errors.type?.errorMessage}
        hasError={errors.type?.hasError}
        {...getOverrideProps(overrides, "type")}
      ></TextField>
      <TextField
        label="From time"
        isRequired={true}
        isReadOnly={false}
        value={fromTime}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              type,
              fromTime: value,
              toTime,
              comment,
            };
            const result = onChange(modelFields);
            value = result?.fromTime ?? value;
          }
          if (errors.fromTime?.hasError) {
            runValidationTasks("fromTime", value);
          }
          setFromTime(value);
        }}
        onBlur={() => runValidationTasks("fromTime", fromTime)}
        errorMessage={errors.fromTime?.errorMessage}
        hasError={errors.fromTime?.hasError}
        {...getOverrideProps(overrides, "fromTime")}
      ></TextField>
      <TextField
        label="To time"
        isRequired={true}
        isReadOnly={false}
        value={toTime}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              type,
              fromTime,
              toTime: value,
              comment,
            };
            const result = onChange(modelFields);
            value = result?.toTime ?? value;
          }
          if (errors.toTime?.hasError) {
            runValidationTasks("toTime", value);
          }
          setToTime(value);
        }}
        onBlur={() => runValidationTasks("toTime", toTime)}
        errorMessage={errors.toTime?.errorMessage}
        hasError={errors.toTime?.hasError}
        {...getOverrideProps(overrides, "toTime")}
      ></TextField>
      <TextField
        label="Comment"
        isRequired={true}
        isReadOnly={false}
        value={comment}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              type,
              fromTime,
              toTime,
              comment: value,
            };
            const result = onChange(modelFields);
            value = result?.comment ?? value;
          }
          if (errors.comment?.hasError) {
            runValidationTasks("comment", value);
          }
          setComment(value);
        }}
        onBlur={() => runValidationTasks("comment", comment)}
        errorMessage={errors.comment?.errorMessage}
        hasError={errors.comment?.hasError}
        {...getOverrideProps(overrides, "comment")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || timestampModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || timestampModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
